import { defineStore } from 'pinia'
import { ref } from 'vue'

type GeneratorsReportDetailsExportParameters = {
    masterDataShowMore?: string
}

export const useGeneratorsReportDetailsExportStateStore = defineStore('exportGeneratorsReportDetailsStateStore', () => {
    const reportDetailsExportParameters = ref<GeneratorsReportDetailsExportParameters>({})

    const resetReportDetailsExportParameters = () => {
        reportDetailsExportParameters.value = {}
    }

    return {
        reportDetailsExportParameters,
        resetReportDetailsExportParameters,
    }
})